import React, { useState } from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { GOOGLE_REVIEWS_URL } from '../mock';

const testimonials = [
  {
    name: 'Enrique Lotierzo',
    date: 'Hace un mes',
    stars: 5,
    text: 'Me asesoraron excelente. Unas genias!'
  },
  {
    name: 'Paola Perez',
    date: 'Hace un mes',
    stars: 5,
    text: 'Excelente atención!'
  },
  {
    name: 'David Raudino',
    date: 'Hace 4 meses',
    stars: 5,
    text: 'Exelente Profesionalismo, eficiencia, rapidez y calidad humana, para cada gestión que han realizado. Totalmente recomendable.'
  },
  {
    name: 'Marta Beatriz Rodriguez',
    date: 'Hace 2 años',
    stars: 5,
    text: 'Excelente la atención del grupo profesional. Solucionaron mi tema con mucha amabilidad.'
  },
  {
    name: 'Leandro Baldesari',
    date: 'Hace 2 años',
    stars: 5,
    text: 'Recomendable. Me solucionó un inconveniente que tenía de hace años en unas semanas.',
    localGuide: true
  },
  {
    name: 'Antonella Garbarini',
    date: 'Hace 2 años',
    stars: 5,
    text: 'Excelente atención! Super agradecida!'
  },
  {
    name: 'Luciana',
    date: 'Hace 2 años',
    stars: 5,
    text: 'Muy buena atención y predisposición, recomiendo.'
  },
  {
    name: 'Juan Villella',
    date: 'Hace 2 años',
    stars: 5,
    text: 'Excente servicio y atención rapida'
  }
];

const getInitials = (name) => {
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const StarRow = ({ count }) => (
  <div className="testimonial-stars" aria-label={`${count} de 5 estrellas`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`testimonial-star ${i < count ? 'filled' : ''}`}
        strokeWidth={1.5}
        aria-hidden="true"
      />
    ))}
  </div>
);

const TestimonialsSection = () => {
  const [showAll, setShowAll] = useState(false);
  return (
    <section className="testimonials-section" id="testimonios">
      <div className="testimonials-container">
        <div className="testimonials-header">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="google-badge google-badge-link"
            data-testid="google-rating-badge"
          >
            <div className="google-badge-stars">
              <StarRow count={5} />
            </div>
            <div className="google-badge-info">
              <p className="google-badge-rating">5.0 en Google · 14 reseñas</p>
              <p className="google-badge-subtitle">Reseñas verificadas de nuestros clientes</p>
            </div>
          </a>
          <h2 className="testimonials-title">Lo que dicen quienes ya confiaron en nosotras.</h2>
          <p className="testimonials-subtitle">
            Historias reales de personas que resolvieron su situación legal con nuestro equipo.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <article
              key={i}
              className={`testimonial-card ${i >= 3 && !showAll ? 'testimonial-extra' : ''}`}
              data-testid={`testimonial-card-${i}`}
            >
              <div className="testimonial-header">
                <div className="testimonial-avatar" aria-hidden="true">
                  {getInitials(t.name)}
                </div>
                <div className="testimonial-meta">
                  <p className="testimonial-name">{t.name}</p>
                  <p className="testimonial-date">
                    {t.localGuide && <span className="local-guide-tag">Local Guide · </span>}
                    {t.date}
                  </p>
                </div>
              </div>
              <StarRow count={t.stars} />
              <p className="testimonial-text">"{t.text}"</p>
            </article>
          ))}
        </div>

        {!showAll && (
          <button
            type="button"
            className="testimonials-more-btn"
            onClick={() => setShowAll(true)}
            data-testid="testimonials-show-more"
          >
            Ver más reseñas
          </button>
        )}

        <div className="testimonials-cta">
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="testimonials-cta-btn"
            data-testid="see-all-reviews-btn"
          >
            <span>Ver todas las reseñas en Google</span>
            <ExternalLink className="w-4 h-4" strokeWidth={2} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
